module.exports = __webpack_public_path__ + "img/map_y.e96470cd.png";